import React, { Component, Suspense } from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ErrorToast = React.lazy(() => import('wix-rich-content-editor/libs/ErrorToast'));
class ErrorNotifier extends Component {
  constructor(props) {
    super(props);
    this.closeToastAfterDelay = () => {
      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(this.close, 4e3);
    };
    this.notify = (error) => {
      this.setState((state) => ({ error, errorCount: state.errorCount + 1 }));
      this.closeToastAfterDelay();
    };
    this.close = () => {
      this.setState({ errorCount: 0 });
    };
    this.state = { error: {}, errorCount: 0 };
  }
  render() {
    const { error, errorCount } = this.state;
    const { isMobile, languageDir } = this.props;
    if (errorCount <= 0) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("div", { style: { display: "contents" }, dir: languageDir }, /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(ErrorToast, __spreadValues({}, { error, errorCount, onClose: this.close, isMobile })), ";"));
  }
}

export { ErrorNotifier as default };
//# sourceMappingURL=ErrorNotifier.js.map
